import { useQuery } from '@tanstack/react-query'

import { getVailHistory } from '@/graphql/queries'
import {
  GetVailHistoryQuery,
  GetVailHistoryQueryVariables,
  VailHistory,
} from '@/utils/api'
import graphQLRequest from '@/utils/graphqlClient'

export async function fetchVailHistory(id?: string | null) {
  if (!id) return null
  const req = await graphQLRequest<
    GetVailHistoryQuery,
    GetVailHistoryQueryVariables
  >(getVailHistory, { id })
  return req
}

export const useGetHistory = (id?: string) => {
  return useQuery({
    enabled: !!id,

    queryFn: async () => {
      if (!id) return {} as VailHistory
      const req = await fetchVailHistory(id)
      return req?.data?.getVailHistory as VailHistory
    },

    queryKey: ['histories', id],
  })
}
